import { useCallback } from 'react';

import size from '@/assets/theme/size';
import useStore from '@/state';
import isCurrentWidthSmallerThan from '@/state/selectors/window/is-current-width-smaller-than';
import { Cta } from '@/typings/generic';

function useVisibleCtas(ctas?: Cta[]): Cta[];
function useVisibleCtas(ctas?: Cta): Cta | undefined;

function useVisibleCtas(ctas?: Cta | Cta[]) {
	const isMobileTabletViewport = useStore((state) =>
		isCurrentWidthSmallerThan(state, size.laptop),
	);

	const hide = useCallback(
		(cta: Cta) => isMobileTabletViewport && !!cta.hideOnMobileViewport,
		[isMobileTabletViewport],
	);

	if (!ctas) {
		return false;
	}

	if (Array.isArray(ctas)) {
		return ctas.filter((cta) => !hide(cta));
	}
	return hide(ctas) ? undefined : ctas;
}

export default useVisibleCtas;
